import React, { useState } from 'react';
import { MdModeEditOutline, MdDelete } from "react-icons/md";
import AdminEditProduct from './AdminEditProduct';
import displayINRCurrency from '../helpers/displayCurrency';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const AdminProductCard = ({ data, fetchData }) => {
    const [editProduct, setEditProduct] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleDeleteProduct = async () => {
        const confirmDelete = window.confirm(
            `Are you sure you want to delete "${data.productName}"?`
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);

            const response = await fetch(
                SummaryApi.deleteProduct(data._id).url,
                {
                    method: SummaryApi.deleteProduct(data._id).method,
                    credentials: "include",
                }
            );

            const result = await response.json();

            if (result.success) {
                toast.success("Product deleted successfully");
                fetchData();
            } else {
                toast.error(result.message || "Delete failed");
            }
        } catch (err) {
            //console.error("Delete product error:", err);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='bg-white p-4 rounded'>
            <div className='w-40'>
                <div className='w-32 h-32 flex justify-center items-center'>
                    <img
                        src={data?.productImage?.[0]}
                        alt=''
                        className='mx-auto object-fill h-full'
                    />
                </div>

                <h1 className='text-ellipsis line-clamp-2'>
                    {data.productName}
                </h1>

                <h3 className='text-ellipsis line-clamp-2'>
                    {data.productCode}
                </h3>

                <div className='flex items-center justify-between mt-1'>
                    <p className='font-semibold'>
                        {displayINRCurrency(data.sellingPrice)}
                    </p>

                    <div className='flex gap-2'>
                        {/* EDIT */}
                        <div
                            className='p-2 bg-green-200 hover:bg-green-600 rounded-full hover:text-white cursor-pointer'
                            onClick={() => setEditProduct(true)}
                        >
                            <MdModeEditOutline />
                        </div>

                        {/* DELETE */}
                        <div
                          className={`p-2 rounded-full cursor-pointer ${
                            loading
                              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                              : "bg-red-200 hover:bg-[#5a3620] hover:text-white"
                          }`}
                          onClick={!loading ? handleDeleteProduct : undefined}
                          title={loading ? "Deleting..." : "Delete Product"}
                        >
                          <MdDelete />
                        </div>
                    </div>
                </div>
            </div>

            {editProduct && (
                <AdminEditProduct
                    productData={data}
                    onClose={() => setEditProduct(false)}
                    fetchData={fetchData}
                />
            )}
        </div>
    );
};

export default AdminProductCard;
